<template>
    <div class="main">
        <MyHeader index="1"></MyHeader>
        <div class="title">
             <div class="container" v-if=" this.$i18n.locale == 'zh_CN'">
                <h2>关于我们</h2>
                <h3>About Us</h3>
            </div>
            <div class="container" v-if=" this.$i18n.locale == 'en_US'">
                <h2>About Us</h2>
                <h3>关于我们</h3>
            </div>
        </div>
        <div class="aboutUsInfo">
            <div class="container">
            
           <nav aria-label="Breadcrumb" class="breadcrumb2">
			  <ul>
				<li><a href="/">{{ $t("header.home") }}</a> </li>
				<li><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 2 16 16">
  <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
</svg></li>
				<li><span aria-current="page">{{ $t("header.aboutUs") }}</span></li>
			  </ul>
			</nav>
			
                <div class="content">
                    <div class="leftMenu">
                        <ul>
                            <li>
                                <router-link to="/aboutUs">
                                    <i>{{$t('ccapp.tit')}}</i>
                                    <b></b>
                                </router-link>
                            </li>
                            <li>
                                <router-link to="/frame">
                                    <i>{{$t('ccapp.tit1')}}</i>
                                    <b></b>
                                </router-link>
                                <ul class="second" style="margin-top: 10px">
                                    <li :class="{'on':pageJson.department == 1}">
                                        <router-link :to="{name:'figure',params:{id:1}}">
                                            <i>{{$t('ccapp.tit2')}}</i>
                                        </router-link>
                                    </li>
                                    <li :class="{'on':pageJson.department == 2}">
                                        <router-link :to="{name:'figure',params:{id:2}}">
                                            <i>{{$t('ccapp.tit3')}}</i>
                                        </router-link>
                                    </li>
                                    <li :class="{'on':pageJson.department == 3}">
                                        <router-link :to="{name:'figure',params:{id:3}}">
                                            <i>{{$t('ccapp.tit4')}}</i>
                                        </router-link>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <router-link to="/job">
                                    <i>{{$t('ccapp.tit5')}}</i>
                                    <b></b>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                    <div class="rightContent">
                        <ul  class="figureList" v-if="pageJson.department == 1 && this.$i18n.locale == 'zh_CN'">
                            <li v-for="item in expertList1" >
                                <router-link :to="'/figureInfo/' + item.id">
                                    <div class="imgBody">
                                        <img :src="item.avatar" alt="">
                                    </div>
                                    <div class="info" >
                                        <h2>{{item.name}}</h2>
                                        <h3>{{item.organization}}</h3>
                                    </div>
                                   
                                </router-link>
                            </li>
                        </ul>
                        <ul  class="figureList" v-if="pageJson.department == 1 && this.$i18n.locale == 'en_US'">
                            <li v-for="item in expertList1" >
                                <router-link :to="'/figureInfo/' + item.id">
                                    <div class="imgBody">
                                        <img :src="item.avatar" alt="">
                                    </div>
                                    <div class="info" >
                                        <h2>{{item.name_en}}</h2>
                                        <h3>{{item.organization_en}}</h3>
                                    </div>
                                   
                                </router-link>
                            </li>
                        </ul>
                       
                        
                        <ul class="figureList" v-if="pageJson.department == 2  && this.$i18n.locale == 'zh_CN'">
                            <li v-for="item in expertList2" >
                                <router-link :to="'/figureInfo/' + item.id">
                                    <div class="imgBody">
                                        <img :src="item.avatar" alt="">
                                    </div>
                                     <div class="info" >
                                        <h2>{{item.name}}</h2>
                                        <h3>{{item.organization}}</h3>
                                    </div>
                                  
                                </router-link>

                            </li>
                        </ul>
                        <ul class="figureList" v-if="pageJson.department == 2 && this.$i18n.locale == 'en_US'">
                            <li v-for="item in expertList2" >
                                <router-link :to="'/figureInfo/' + item.id">
                                    <div class="imgBody">
                                        <img :src="item.avatar" alt="">
                                    </div>
                                     <div class="info" >
                                        <h2>{{item.name_en}}</h2>
                                        <h3>{{item.organization_en}}</h3>
                                    </div>
                                  
                                </router-link>

                            </li>
                        </ul>
                        
                        <ul class="figureList" v-if="pageJson.department == 3 && this.$i18n.locale == 'zh_CN'">
                            <li v-for="item in expertList3">
                                <router-link :to="'/figureInfo/' + item.id">
                                    <div class="imgBody">
                                        <img :src="item.avatar" alt="wangzifa">
                                    </div>
                                      <div class="info" >
                                        <h2>{{item.name}}</h2>
                                        <h3>{{item.organization}}</h3>
                                    </div>
                                  
                                </router-link>
                            </li>
                        </ul>
                         <ul class="figureList" v-if="pageJson.department == 3 && this.$i18n.locale == 'en_US'">
                            <li v-for="item in expertList3">
                                <router-link :to="'/figureInfo/' + item.id">
                                    <div class="imgBody">
                                        <img :src="item.avatar" alt="wangzifa">
                                    </div>
                                     <div class="info" >
                                        <h2>{{item.name_en}}</h2>
                                        <h3>{{item.organization_en}}</h3>
                                    </div>
                                  
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <MyFooter></MyFooter>
    </div>
</template>

<script>
    import MyHeader from './common/MyHeader';
    import MyFooter from './common/MyFooter';
    import $ from 'jquery';
    import {createExpert, getExpertList, getExpertDetails, deleteExpert, putExpert} from '@/services/expert';

    export default {
        name: "FigurePage",
        components: { MyHeader,MyFooter },
        data(){
            return{
                pageJson:{
                    page_size:999,
                    page:1,
                    department:1,
                  
                },
                expertList1: [],
                expertList2: [],
                expertList3: [],
            }
        },
        watch:{
		  $route(to,from){
			
			
			this.pageJson.department = to.params.id;
			
            this.getList(res => {
                    let list = res.items;
                    if (this.pageJson.department == 1){
                        this.expertList1 = list;
                    } else if (this.pageJson.department == 2){
                        this.expertList2 = list;
						console.log(list);
                    } else if (this.pageJson.department == 3){
                        this.expertList3 = list;
                    }
                });
		  }
		},
        mounted(){
        	
        	
            this.pageJson.department = this.$route.params.id;
            
            this.getList(res => {
                    let list = res.items;
                    if (this.pageJson.department == 1){
                        this.expertList1 = list;
                    } else if (this.pageJson.department == 2){
                        this.expertList2 = list;

                    } else if (this.pageJson.department == 3){
                        this.expertList3 = list;
                    }
                });
        },
        methods:{
            
            getList(cb){
            	
                getExpertList(this.pageJson).then(res => {
                    if (typeof cb === 'function'){
                        cb(res);
                    }
                }).catch(err => {});
            }
        }
    }
</script>

<style lang="scss" scoped>
    .main{
        .title{
            height:380px;
            background: url("./image/aboutUsImg.jpg") no-repeat center center;
            background-size: cover;
            .container{
                h2{
                    padding-top: 180px;
                    text-align: center;
                    color: #304656;
                    height:42px;
                    font-size:32px;
                    font-weight:bold;
                    line-height:42px;
                }
                h3{
                    text-align: center;
                    height:29px;
                    font-size:22px;
                    line-height:29px;
                    color: #304656;
                }
            }
        }
        .aboutUsInfo{
            .container{
                border-top: 1px solid #E6E6E6;
                .content{
                    margin-top: 30px;
                    overflow: hidden;
                    margin-bottom: 48px;
                    .leftMenu{
                        width: 246px;
                        float: left;
                        ul{
                            li{
                                line-height: 36px;
                                margin-bottom: 10px;
                                &:last-child{
                                    margin-bottom: 0;
                                }
                                &:nth-of-type(2){

                                }
                                a{
                                    padding: 0 16px;
                                    border-radius: 18px;
                                    display: block;
                                    height: 100%;
                                    overflow: hidden;
                                }
                                i{
                                    display: inline-block;
                                    float: left;
                                    color: #252525;
                                    font-size: 16px;
                                }
                                b{
                                    display: inline-block;
                                    float: right;
                                    width: 30px;
                                    height: 36px;
                                    background: url("./image/yy2.png") no-repeat center center;
                                    background-size: 100%;
                                    line-height: 36px;
                                }

                            }
                            .on{

                                a{
                                    background: #13AE67;
                                }
                                i{
                                    color: #FFFFFF;
                                }
                                b{
                                    background: url("./image/yy.png") no-repeat center center;
                                    background-size: 86%;
                                    transform:rotate(90deg);
                                }
                            }
                            
                            .second{
                                li{
                                    a{
                                        text-indent: 20px;
                                        background: transparent;
                                        i{
                                            color: #252525;
                                        }
                                    }
                                }
                                .on{

                                    a{
                                        background: #13AE67;
                                    }
                                    i{
                                        color: #FFFFFF;
                                    }
                                    b{
                                        background: url("./image/yy.png") no-repeat center center;
                                        background-size: 86%;
                                        transform:rotate(90deg);
                                    }
                                }
                            }
                        }
                    }
                    .rightContent{
                        float: right;
                        margin-left: 88px;
                        width: 866px;
                        .figureList{

                            margin: 10px 0 10px 66px;
                            li{
                                float: left;
                                width: 250px;
                                height: 317-30px;
                                transition: all .3s;
                                padding-top: 30px;
                                margin-right: 22px;
                                margin-bottom: 10px;
                                &:nth-of-type(3n){
                                    margin-right: 0;
                                }
                                a{
                                    display: block;
                                }
                                .imgBody{
                                    width: 190px;
                                    height: 190px;
                                    border-radius: 50%;
                                    overflow: hidden;
                                    margin: 0 auto;
                                    img{
                                        width: 100%;
                                    }
                                }
                                .info{
                                    margin-top: 10px;
                                    h2{
                                        height: 26px;
                                        line-height: 26px;
                                        color: #252525;
                                        text-align: center;
                                    }
                                    h3{
                                        height: 20px;
                                        line-height: 20px;
                                        font-size: 14px;
                                        color: #999999;
                                        margin-top: 12px;
                                        text-align: center;
                                    }
                                }
                                &:hover{
                                    box-shadow: 0 2px 7px 0 rgba(44,73,102,0.41);
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    .back{
        background: #13AE67;
        border-radius: 18px;
    }
</style>
